module.exports = __webpack_public_path__ + "static/img/无锡案例图.bca77fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/无锡案例图.png
// module id = XTBc
// module chunks = 2